
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';
import u from '@/utility/utility';
import ListOrder from './components/ListOrder.vue';
import { Order } from '@/models/order';
import { Customer } from '@/models/customer';
import authService from '@/services/auth-services';
import orderService from '@/services/order-service';
import depositService from '@/services/deposit-services';

@Component({
    components: {
        Loading,
        'list-order': ListOrder
    }
})
export default class AddNewPaymentRequest extends Vue {
    private listOrders: Order[] = [];
    private customerInfo: Customer = {};
    private isLoading = false;

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get totalChoose() {
        return this.listOrders.filter(x => x.isChecked === true).length;
    }

    get totalWeight() {
        return this.listOrders.reduce((total: number, order: Order) => {
            return total + (order.isChecked ?  (order.orderWeight || 0) : 0);
        }, 0);
    }

    get totalAmount() {
        return this.listOrders.reduce((total: number, order: Order) => {
            return total + (order.isChecked ?  (order.totalAmountVND || 0) : 0);
        }, 0);
    }

    get totalDeposit() {
        return this.listOrders.reduce((total: number, order: Order) => {
            return total + (order.isChecked ? (order.deposit || 0) : 0);
        }, 0);
    }

    get paymentRequestOrders() {
        return this.$store.state[APP_CONFIG.stateKey.cartState].paymentRequestOrders;
    }

    private async created() {
        await this.getListOrder();
    }

    private getStatus(value: any) {
        return DATA.orderStatus.find(x => x.value === value) || { value: 0, name: 'N/A', color: '#49494a' };
    }

    private async getListOrder() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        
        paramsFilter.filters.push({
                column: 'Status',
                value: [7,8],
                condition: 'in'
            });
        paramsFilter.filters.push({
            column: 'TotalPackageUnRequest',
            value: 0,
            condition: 'greater_than'
        });
        this.isLoading = true;
        let result = await orderService.orderList(1, 10000, paramsFilter.filters, paramsFilter.quickFilters);
        const tmpListOrder: any[] = [];
        if (result && result.data && result.data.status === 200) {
            for (const item of result.data.data) {
                const order: any = {};
                order.id = item.ID;
                order.orderType = 1;
                order.createdDate = item.CreatedDate;
                order.status = item.Status;
                order.statusDetail = this.getStatus(item.Status);
                order.totalAmountVND = item.TotalAmountVND;
                order.deposit = item.Deposit;
                order.imageOrigin = item.image_origin;
                order.isChecked = this.paymentRequestOrders && this.paymentRequestOrders.find(x => x.id === item.ID) ? true : false;
                order.orderWeight = item.UnpaidWeight;
                tmpListOrder.push(order);
            }
        }
        result = await depositService.getDeposit(1, 10000, paramsFilter.filters, paramsFilter.quickFilters);
        if (result && result.data && result.data.status === 200) {
            for (const item of result.data.data) {
                const order: any = {};
                order.id = item.ID;
                order.orderType = 2;
                order.createdDate = item.CreatedDate;
                order.status = item.Status;
                order.statusDetail = this.getStatus(item.Status);
                order.totalAmountVND = item.TotalPriceVND;
                order.deposit = item.Payment;
                order.imageOrigin = item.ProductImage;
                order.isChecked = this.paymentRequestOrders && this.paymentRequestOrders.find(x => x.id === item.ID) ? true : false;
                order.orderWeight = item.UnpaidWeight;
                tmpListOrder.push(order);
            }
        }
        this.listOrders = tmpListOrder;
        this.isLoading = false;
    }

    private async submitPaymentRequest() {        
        (window['getApp'] as any).$emit('SET_SELECTED_ORDER', this.listOrders.filter(x => x.isChecked === true));
        this.$router.push({ name: 'yeu-cau-giao-hang2' });
    }

    private async onCheckAll(isCheckAll: boolean) {
        this.listOrders = this.listOrders.map(x => {
            return {
                ...x,
                isChecked: isCheckAll
            }
        });
    }
}
